/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.assetLibraryModule')

.directive('bulbAssetLibraryVideoSplashImages', bulbAssetLibraryVideoSplashImages);

function bulbAssetLibraryVideoSplashImages() {
  return {
    restrict: 'E',
    scope: {
      splashImages : '=',
      selectedSplashImageId : '=',
      currentTarget : '='
    },
    controller: function() {},
    controllerAs: 'assetLibrarySplashImagesCtrl',
    bindToController: true,
    templateUrl: 'ajs/assetlibrary/assetlibrary-splash-images.html'
  };
}
